var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { singleton } from "tsyringe";
import { makeImmutable } from "../core";
import { InternalParameterSet, ParameterSet } from "./Menu";
let ParameterScopeProvider = class ParameterScopeProvider {
    constructor() {
        makeImmutable(this);
    }
    fromProductInstance(productInstance, fulfillmentMethod) {
        return new ParameterSet({
            internal: new InternalParameterSet({
                fulfillmentMethod,
                splitToHalves: productInstance.parts.type === "Halves",
            }),
            custom: productInstance.customParameters,
        });
    }
    fromVariant(variant, fulfillmentMethod) {
        return new ParameterSet({
            internal: new InternalParameterSet({
                fulfillmentMethod,
                splitToHalves: variant.productTypes.type === "Halves",
            }),
            custom: variant.customParameterChoices,
        });
    }
};
ParameterScopeProvider = __decorate([
    singleton(),
    __metadata("design:paramtypes", [])
], ParameterScopeProvider);
export { ParameterScopeProvider };
